import _implicitStylesheets from "./banner.css";
import _implicitScopedStylesheets from "./banner.scoped.css?scoped=true";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h1${"c0"}${"s0"}${2}>${"t1"}</h1>`;
const $fragment2 = parseFragment`<p${"c0"}${"s0"}${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<img${"a0:src"}${"a0:alt"}${"s0"}${3}>`;
const $fragment4 = parseFragment`<p class="axwp-banner__image-caption${0}"${2}>${"t1"}</p>`;
const $fragment5 = parseFragment`<div${"c0"}${2}><img${"a1:src"}${"a1:alt"} class="axwp-banner__backdrop-image${0}"${2}></div>`;
const $fragment6 = parseFragment`<p class="axwp-banner__image-caption axwp-banner__image-caption-backdrop${0}"${2}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "axwp-banner__content": true
  },
  key: 4
};
const stc1 = {
  classMap: {
    "axwp-banner__image-wrapper": true
  },
  key: 12
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, t: api_text, c: api_custom_element, h: api_element} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.wrapperClass),
    style: $cmp.wrapperStyle,
    key: 0
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.blockClass),
    style: $cmp.blockStyle,
    key: 1
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.containerClass),
    key: 2
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.contentWrapperClass),
    key: 3
  }, [$cmp.shouldDisplayContent ? api_element("div", stc0, [$cmp.hasTitle ? api_static_fragment($fragment1, 6, [api_static_part(0, {
    className: api_normalize_class_name($cmp.titleClass),
    style: $cmp.titleStyle
  }, null), api_static_part(1, null, api_dynamic_text($cmp.title))]) : null, $cmp.hasContentText ? api_static_fragment($fragment2, 8, [api_static_part(0, {
    className: api_normalize_class_name($cmp.contentClass),
    style: $cmp.contentStyle
  }, null), api_static_part(1, null, api_dynamic_text($cmp.content))]) : null, $cmp.hasCta ? api_element("div", {
    className: api_normalize_class_name($cmp.ctaDesktopClass),
    key: 9
  }, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.ctaLink,
      "label": $cmp.ctaText
    },
    key: 10
  }, [api_text(api_dynamic_text($cmp.ctaText))])]) : null]) : null, api_element("div", {
    className: api_normalize_class_name($cmp.imageClass),
    key: 11
  }, [api_element("div", stc1, [$cmp.image ? api_static_fragment($fragment3, 14, [api_static_part(0, {
    style: $cmp.imageStyle,
    attrs: {
      "src": $cmp.image,
      "alt": $cmp.imageAlt
    }
  }, null)]) : null, !$cmp.hasBackdrop ? $cmp.hasImageCaption ? api_static_fragment($fragment4, 16, [api_static_part(1, null, api_dynamic_text($cmp.imageCaption))]) : null : null, $cmp.hasBackdrop ? api_static_fragment($fragment5, 18, [api_static_part(0, {
    className: api_normalize_class_name($cmp.backdropClass)
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.backdropUrl,
      "alt": $cmp.selectedBackdrop
    }
  }, null)]) : null])]), $cmp.hasCta ? api_element("div", {
    className: api_normalize_class_name($cmp.ctaMobileClass),
    key: 19
  }, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.ctaLink,
      "label": $cmp.ctaText
    },
    key: 20
  }, [api_text(api_dynamic_text($cmp.ctaText))])]) : null, $cmp.hasBackdrop ? $cmp.hasImageCaption ? api_static_fragment($fragment6, 22, [api_static_part(1, null, api_dynamic_text($cmp.imageCaption))]) : null : null])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-623i7i8hh23";
tmpl.legacyStylesheetToken = "undefined-_banner";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
